import styled from '@emotion/styled';

export default styled.div`
	p {
		margin: 0 0 5px;
	}

	${props => props.theme.info || ''}
`;
